import { useQuery } from 'react-query'
import styled from 'styled-components'

import { api } from '@h2/api'
import { Skeleton } from '@h2/components/loading/skeleton'

import { ContinueSkillsDecoderCard } from './promotionCards/continueSkillsDecoderCard'
import { ChooseGoalCard } from './promotionCards/chooseGoalCard'
import { BlankCard } from './promotionCards/blankCard'
import { ContinueTowardsGoalCard } from './promotionCards/continueTowardsGoalCard'
import { ResumeLessonCard } from './promotionCards/resumeLessonCard'
import { ChooseGoalStepCard } from './promotionCards/chooseGoalStepCard'
import { PromotionCard } from './promotionCards/promotionCard'

const Wrap = styled.div`
  flex-grow: 1;
`
const RecommendedNextStep = () => {
  const { data: recommendation, isFetching } = useQuery(
    'recommendation-next-step',
    () => {
      return api.fetch('/recommendations/nextstep', { method: 'GET' })
    }
  )

  if (isFetching) {
    return (
      <Wrap>
        <Skeleton display="block" height="100px" width="360px" />
      </Wrap>
    )
  }

  if (!recommendation) {
    return null
  }

  const step = recommendation.recommendationId

  switch (step) {
    case 'promotion':
      return (
        <Wrap>
          <PromotionCard nextStep={recommendation} />
        </Wrap>
      )
    case 'skillsDecoder':
      return (
        <Wrap>
          <ContinueSkillsDecoderCard />
        </Wrap>
      )
    case 'chooseGoal':
      return (
        <Wrap>
          <ChooseGoalCard />
        </Wrap>
      )
    case 'continueLesson':
      return (
        <Wrap>
          <ResumeLessonCard recommendation={recommendation} />
        </Wrap>
      )
    case 'chooseStepInGoal':
      return (
        <Wrap>
          <ChooseGoalStepCard recommendation={recommendation} />
        </Wrap>
      )
    case 'continueTowardsGoal':
      return (
        <Wrap>
          <ContinueTowardsGoalCard nextStep={recommendation} />
        </Wrap>
      )
    default:
      return (
        <Wrap>
          <BlankCard nextStep={recommendation} />
        </Wrap>
      )
  }
}

export { RecommendedNextStep }
